import React from "react";
import firebase from "firebase.config";
import {
  exportNewsletterToWord,
  exportNewsletterToPdf
} from "utils/exportNewsletter";

export default class ExistingMagazines extends React.Component {
  state = {
    selectedNewsletter: null,
    exporting: false
  };

  detailRef = React.createRef();

  rawMarkup(param) {
    return { __html: param };
  }

  handleExportWord = () => {
    const selected = this.state.selectedNewsletter;
    const key = this.state.selectedKey || "";
    if (!selected) return;
    exportNewsletterToWord(
      selected.data,
      selected.pageNames,
      key.split("+")[0],
      key.split("+")[1]
    );
  };

  handleExportPdf = async () => {
    const key = this.state.selectedKey || "";
    this.setState({ exporting: true });
    try {
      await exportNewsletterToPdf(
        this.detailRef.current,
        key.split("+")[0],
        key.split("+")[1]
      );
    } catch (err) {
      console.error(err);
      alert("PDF 생성 중 오류가 발생했습니다. 다시 시도해 주세요.");
    }
    this.setState({ exporting: false });
  };

  // "2024-05-03+2" 형태의 key 에서 사람이 읽기 쉬운 날짜로 변환
  formatDate(key) {
    return new Date(Date.parse(key.split("+")[0]))
      .toUTCString()
      .split("00:00")[0];
  }

  editNewsLetter = (key, edit) => {
    this.props.editPage(key, edit);
  };

  deleteNewsLetter = key => {
    let res = window.confirm(
      "이 뉴스레터를 삭제하시겠습니까? 삭제하면 복구할 수 없습니다."
    );
    if (res) {
      console.log(key);
      firebase
        .database()
        .ref("groupsData/" + this.props.groupPath + "/newsletters/" + key)
        .remove();
    }
    console.log("groupsData/" + this.props.groupPath + "/newsletters/" + key);
  };

  render() {
    console.warn(this.props);
    let keys = this.props.newsletters
      ? Object.keys(this.props.newsletters)
      : [];
    const selected = this.state.selectedNewsletter;

    return (
      <div className="content">
        <div className="mx-auto w-full max-w-5xl px-2 pb-10">
          {/* 헤더 */}
          <div className="mb-6 flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-gray-800">뉴스레터 목록</h2>
              <p className="mt-1 text-sm text-gray-500">
                지금까지 만든 뉴스레터입니다. 카드를 눌러 내용을 보거나 수정·복제·삭제할
                수 있어요.
              </p>
            </div>
            <span className="hidden rounded-full bg-sky-100 px-3 py-1 text-sm font-semibold text-sky-600 sm:inline-block">
              총 {keys.length}개
            </span>
          </div>

          {/* 빈 상태 */}
          {keys.length === 0 ? (
            <div className="rounded-2xl border-2 border-dashed border-gray-200 bg-white p-12 text-center">
              <div className="mb-3 text-4xl">📭</div>
              <h3 className="mb-1 text-lg font-bold text-gray-700">
                아직 만든 뉴스레터가 없어요
              </h3>
              <p className="text-sm text-gray-500">
                위의 <b>[Add New Newsletter]</b> 버튼을 눌러 첫 번째 뉴스레터를
                만들어 보세요.
              </p>
            </div>
          ) : (
            /* 카드 그리드 */
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {keys.map((key, index) => (
                <div
                  key={index}
                  className="flex flex-col rounded-2xl border border-gray-100 bg-white p-5 shadow-sm transition hover:shadow-md"
                >
                  <div className="mb-4 flex items-start justify-between">
                    <div>
                      <div className="text-xs font-semibold uppercase tracking-wide text-gray-400">
                        발행일
                      </div>
                      <div className="mt-0.5 text-base font-bold text-gray-800">
                        {this.formatDate(key)}
                      </div>
                    </div>
                    <span className="shrink-0 rounded-full bg-sky-100 px-3 py-1 text-xs font-bold text-sky-600">
                      {key.split("+")[1]}주차
                    </span>
                  </div>

                  <button
                    type="button"
                    className="mb-3 inline-flex w-full items-center justify-center gap-1 rounded-xl bg-sky-500 px-4 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-sky-600"
                    onClick={() =>
                      this.setState({
                        selectedNewsletter: this.props.newsletters[key],
                        selectedKey: key
                      })
                    }
                  >
                    👁️ 내용 보기
                  </button>

                  <div className="grid grid-cols-3 gap-2">
                    <button
                      type="button"
                      className="rounded-lg border border-gray-200 bg-white px-2 py-2 text-xs font-semibold text-gray-600 transition hover:bg-gray-50"
                      onClick={() => this.editNewsLetter(key, true)}
                    >
                      ✏️ 수정
                    </button>
                    <button
                      type="button"
                      className="rounded-lg border border-gray-200 bg-white px-2 py-2 text-xs font-semibold text-gray-600 transition hover:bg-gray-50"
                      onClick={() => this.editNewsLetter(key)}
                    >
                      📑 복제
                    </button>
                    <button
                      type="button"
                      className="rounded-lg border border-rose-200 bg-white px-2 py-2 text-xs font-semibold text-rose-500 transition hover:bg-rose-50"
                      onClick={() => this.deleteNewsLetter(key)}
                    >
                      🗑️ 삭제
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* 상세 보기 패널 */}
          {selected && (
            <div className="mt-8 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
              <div className="mb-6 flex flex-wrap items-center justify-between gap-3 border-b border-gray-100 pb-4">
                <h3 className="text-lg font-bold text-gray-800">
                  {this.formatDate(this.state.selectedKey)} ·{" "}
                  {this.state.selectedKey.split("+")[1]}주차 뉴스레터
                </h3>
                <div className="flex flex-wrap items-center gap-2">
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 rounded-lg bg-sky-500 px-4 py-1.5 text-sm font-semibold text-white shadow-sm transition hover:bg-sky-600"
                    onClick={this.handleExportWord}
                  >
                    📄 Word
                  </button>
                  <button
                    type="button"
                    disabled={this.state.exporting}
                    className="inline-flex items-center gap-1 rounded-lg bg-rose-500 px-4 py-1.5 text-sm font-semibold text-white shadow-sm transition hover:bg-rose-600 disabled:cursor-not-allowed disabled:opacity-60"
                    onClick={this.handleExportPdf}
                  >
                    {this.state.exporting ? "⏳ 생성 중…" : "🖨️ PDF"}
                  </button>
                  <button
                    type="button"
                    className="rounded-lg border border-gray-300 bg-white px-4 py-1.5 text-sm font-semibold text-gray-600 transition hover:bg-gray-50"
                    onClick={() =>
                      this.setState({
                        selectedNewsletter: null,
                        selectedKey: null
                      })
                    }
                  >
                    ✕ 닫기
                  </button>
                </div>
              </div>

              <div ref={this.detailRef} style={{ backgroundColor: "#fff" }}>
              {/* 1페이지 */}
              <div className="mb-8">
                <h4 className="mb-3 inline-block rounded-md bg-sky-50 px-3 py-1 text-sm font-bold text-sky-600">
                  {selected.pageNames.page1 || "1페이지"}
                </h4>
                <div className="mb-4 flex items-center gap-4">
                  {selected.data.page1.image && (
                    <img
                      src={selected.data.page1.image}
                      alt=""
                      className="h-20 w-20 rounded-lg object-cover shadow"
                    />
                  )}
                  <h5 className="text-base font-semibold text-gray-700">
                    {selected.data.page1.imageText}
                  </h5>
                </div>
                {selected.data.page1.tableArray.map((table, i) => (
                  <div
                    key={i}
                    className="mb-3 overflow-hidden rounded-lg border border-gray-200"
                  >
                    <div className="bg-gray-50 px-4 py-2 text-sm font-bold text-gray-700">
                      {table.header}
                    </div>
                    <table className="w-full text-sm">
                      <tbody>
                        {table.rows.map((row, j) => (
                          <tr key={j} className="border-t border-gray-100">
                            <td className="w-2/5 px-4 py-2 align-top font-medium text-gray-800">
                              {row.column1}
                            </td>
                            <td className="px-4 py-2 align-top text-gray-600">
                              {row.column2}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>

              {/* 2페이지 */}
              <div className="mb-8">
                <h4 className="mb-3 inline-block rounded-md bg-sky-50 px-3 py-1 text-sm font-bold text-sky-600">
                  {selected.pageNames.page2 || "2페이지"}
                </h4>
                {selected.data.page2.map((table, i) => (
                  <div
                    key={i}
                    className="mb-3 overflow-hidden rounded-lg border border-gray-200"
                  >
                    <div className="bg-gray-50 px-4 py-2 text-sm font-bold text-gray-700">
                      {table.header}
                    </div>
                    <div className="px-4 py-3 text-sm text-gray-600">
                      {table.text}
                    </div>
                  </div>
                ))}
              </div>

              {/* 3페이지 */}
              <div className="mb-2">
                <h4 className="mb-3 inline-block rounded-md bg-sky-50 px-3 py-1 text-sm font-bold text-sky-600">
                  {selected.pageNames.page3 || "3페이지"}
                </h4>
                <div className="overflow-hidden rounded-lg border border-gray-200">
                  <div className="bg-gray-50 px-4 py-2 text-sm font-bold text-gray-700">
                    {selected.data.page3.header}
                  </div>
                  <div
                    className="px-4 py-3 text-sm text-gray-600"
                    dangerouslySetInnerHTML={this.rawMarkup(
                      selected.data.page3.text
                    )}
                  />
                </div>
              </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
